(() => {
  'use strict';
  const init = () => {
    const fit = document.getElementById('help-fit-dialog');
    const contact = document.getElementById('help-contact-dialog');
    if (!fit || !contact || fit.dataset.ready) return;
    fit.dataset.ready = 'true';
    let returnFocus;
    const close = dialog => dialog?.close();
    const open = (dialog, trigger) => {
      returnFocus = trigger?.closest('[data-nav-panel]') ? document.querySelector('.site-nav-panel--help')?.closest('.site-nav-item')?.querySelector('[data-nav-toggle]') : trigger;
      if (typeof DesktopNav !== 'undefined') DesktopNav._closeAll?.();
      if (typeof SurfaceScroll !== 'undefined') SurfaceScroll.acquire('help');
      dialog.showModal();
    };
    [fit, contact].forEach(dialog => {
      dialog.addEventListener('close', () => {
        if (typeof SurfaceScroll !== 'undefined') SurfaceScroll.release('help');
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        if (event.target.closest('[data-help-close]')) close(dialog);
        if (event.target === dialog) {
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(dialog);
        }
      });
    });
    document.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('[data-help-contact], [data-help-fit], [data-help-dismiss], [data-help-current-fit]');
      if (!link) return;
      if (link.hasAttribute('data-help-dismiss')) {
        if (typeof DesktopNav !== 'undefined') DesktopNav._closeAll?.();
        return;
      }
      if (link.hasAttribute('data-help-current-fit')) {
        const button = document.getElementById('pdp-size-guide-open');
        if (!button) return;
        event.preventDefault(); close(fit); button.click(); return;
      }
      event.preventDefault();
      if (link.hasAttribute('data-help-contact')) {
        const option = Array.from(contact.querySelectorAll('#help-topic option')).find(o => o.dataset.topic === link.dataset.helpContact);
        if (option) option.selected = true;
        open(contact, link);
      } else { open(fit, link); renderSeeds(); }
    });
    const submitted = contact.querySelector('[data-help-submitted]');
    if (submitted) open(contact, document.querySelector('[data-nav-toggle]'));
    // Topic URLs also work when opened in a new tab or followed without interception.
    const topic = new URLSearchParams(location.search).get('topic');
    if (location.pathname.endsWith('/pages/contact') && ['order','sizing','custom','other'].includes(topic)) {
      const option = contact.querySelector('[data-topic="' + topic + '"]');
      if (option) option.selected = true;
      open(contact);
    }

    const garment = fit.querySelector('#help-garment');
    const search = fit.querySelector('#help-design');
    const status = fit.querySelector('#help-fit-status');
    const results = fit.querySelector('#help-fit-results');
    const browse = fit.querySelector('#help-fit-browse');
    let seeds = {};
    try { seeds = JSON.parse(fit.querySelector('#help-fit-seeds').content.textContent); } catch (_) {}
    let request = 0, controller, timer;
    const classify = title => /long[ -]?sleeve/i.test(title) ? 'longsleeves' : /hoodie/i.test(title) ? 'hoodies' : /crewneck|sweatshirt/i.test(title) ? 'crews' : /t[ -]?shirt|tee/i.test(title) ? 'tees' : '';
    const render = products => {
      const fragment = document.createDocumentFragment();
      products.forEach(product => {
        const url = new URL(product.url, location.origin);
        if (url.origin !== location.origin) return;
        url.searchParams.set('size-guide', '1');
        const link = document.createElement('a'); link.href = url.pathname + url.search;
        const imageUrl = product.image?.url || product.featured_image?.url || product.image;
        if (typeof imageUrl === 'string' && imageUrl) {
          const image = document.createElement('img'); image.src = imageUrl; image.alt = ''; image.width = 54; image.height = 68; image.loading = 'lazy'; link.append(image);
        }
        const label = document.createElement('span'); label.textContent = product.title;
        const action = document.createElement('small'); action.textContent = status.dataset.guide + ' '; label.append(action); link.append(label); fragment.append(link);
      });
      results.replaceChildren(fragment);
      results.setAttribute('aria-busy', 'false');
    };
    function renderSeeds() {
      clearTimeout(timer); controller?.abort(); request++;
      search.value = '';
      const group = seeds[garment.value] || { products: [], url: '/collections/all' };
      browse.href = group.url; render(group.products);
      status.textContent = group.products.length ? status.dataset.popular : status.dataset.empty;
    }
    garment.addEventListener('change', renderSeeds);
    search.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort(); const current = ++request;
      const query = search.value.trim();
      if (!query) { renderSeeds(); return; }
      results.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.loading;
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const root = window.Shopify?.routes?.root || '/';
          const url = new URL(root + 'search/suggest.json', location.origin);
          const term = {tees:'t-shirt',hoodies:'hoodie',crews:'crewneck',longsleeves:'long sleeve'}[garment.value];
          url.searchParams.set('q', query + ' ' + term);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '10');
          const response = await fetch(url, {signal:controller.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (current !== request) return;
          const words = query.toLocaleLowerCase().split(/\s+/).filter(Boolean);
          const products = (data.resources?.results?.products || []).filter(p => classify(p.title) === garment.value && words.every(word => p.title.toLocaleLowerCase().includes(word))).slice(0,6);
          render(products); status.textContent = products.length ? status.dataset.guide : status.dataset.empty;
        } catch (error) {
          if (error.name === 'AbortError' || current !== request) return;
          render([]); status.textContent = status.dataset.error;
        }
      }, 220);
    });
    fit.addEventListener('close', () => { clearTimeout(timer); controller?.abort(); request++; });
    // Native details remain usable without JavaScript; animate only the answer content.
    document.querySelectorAll('.help-answer').forEach(answer => answer.addEventListener('toggle', () => {
      if (answer.open && !matchMedia('(prefers-reduced-motion: reduce)').matches) answer.querySelector('div')?.animate([{opacity:0,transform:'translateY(-4px)'},{opacity:1,transform:'translateY(0)'}],{duration:200,easing:'ease-out'});
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
